window.onload = function() {
    // 页面初始化
    obj.init();
};
var obj = {
    init: function() {
        this.preloading(); // 预加载
        this.swiper(); // swiper轮播
        this.indexBind(); // 所有绑定事件
        this.downUrl(); // 获取页面id
        this.newYearTime(); // 新年设置
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            }

            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').removeClass('landing');
            setTimeout(function() {
                // $('.preloading').remove();
                obj.swiper();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/njsm/images/mobile/m_jdt.png',
            '//static.qcplay.com/snail/njsm/images/mobile/m_dt_sz.png',
            '//static.qcplay.com/snail/njsm/images/mobile/m_index_04.png',
            '//static.qcplay.com/snail/njsm/images/mobile/inf_bg_00.png',
            '//static.qcplay.com/snail/njsm/images/mobile/inf_bg_01.png',
            '//static.qcplay.com/snail/njsm/images/mobile/cloud_01.png',
            '//static.qcplay.com/snail/njsm/images/mobile/cloud_02.png',
            '//static.qcplay.com/snail/njsm/images/mobile/m_title.png',
            '//static.qcplay.com/snail/njsm/images/mobile/header_bg.png',
            '//static.qcplay.com/snail/njsm/images/mobile/shine.png',
            '//static.qcplay.com/snail/njsm/images/mobile/logo_img.png',
            '//static.qcplay.com/snail/njsm/images/mobile/btn_down_01.png',
            '//static.qcplay.com/snail/njsm/images/mobile/btn_on.png',
            '//static.qcplay.com/snail/njsm/images/mobile/snail_04.png',
            '//static.qcplay.com/snail/njsm/images/mobile/camera.png',
            '//static.qcplay.com/snail/njsm/images/mobile/film.png',
        ]);
    },
    // 所有绑定事件
    swiper: function() {
        function pageSwiper() {
            var swiperH = new Swiper('.swiper-container-h', {
                pagination: '.swiper-pagination-h',
                paginationClickable: true,
                direction: 'vertical',
                resistanceRatio: 0,
                mousewheelControl: true,
                slidesPerView: 'auto',
                onInit: function(swiper) { //Swiper2.x的初始化是onFirstInit
                    swiperAnimateCache(swiper); //隐藏动画元素
                    swiperAnimate(swiper); //初始化完成开始动画
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
            });
        }

        pageSwiper();

        function tabSwiperTwo(swiperClass, swiperPagin) {
            var swiper3 = new Swiper(swiperClass, {
                pagination: swiperPagin,
                scrollbarDraggable: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                paginationClickable: true,
                spaceBetween: 50,
                speed: 300,
                loop: true,
                observer: true,
                observeParents: true,
                onSlideChangeEnd: function(swiper) {
                    swiper.update();
                }
            });

            return swiper3;
        }

        var swiperX1 = tabSwiperTwo('.swiper-container2', '.swiper-pagination');
        // var swiperX2 = tabSwiperTwo('.swiper-container3', '.swiper-pagination-02');
        var dataNum = null
        var dataNumber = null;

        $('.swiper-container3 .slide-01').on('click', '.banner', function(event) {
            dataNum = $(this).attr('data');
            // swiperX2.slideTo(2, 300, false);
        });

        $('.swiper-container3 .slide-02').on('click', '.act-box', function(event) {
            dataNum = $(this).attr('data');
            $('.act-dec-popup-2').fadeIn().find('.inf-0' + dataNum).show().scrollTop(0);
        });

        // 查看详情
        $('.swiper-container2 .slide-01 .detail').on('click', function(event) {
            $('.act-dec-detail').fadeIn().find('.inf-01').show().scrollTop(0);
            dataNumber = 1
        });
        $('.swiper-container2 .slide-02 .detail').on('click', function(event) {
            $('.act-dec-detail').fadeIn().find('.inf-02').show().scrollTop(0);
            dataNumber = 2
        });
        //适龄弹窗
        $('.year_box').on('click', function(event) {
            $('.year_pop').fadeIn();
        });

        $('.close-btn').click(function(event) {
            $('.act-dec-detail').fadeOut().find('.inf').hide();
            $('.act-dec-popup-2').fadeOut().find('.inf').hide();
            $('.year_pop').fadeOut();
            $('.previous_pop').fadeOut();
        });
    },
    downUrl: function() {
        var iosUrl = 'https://apps.apple.com/cn/app/id1507966188';
        var andUrl = 'http://download2.qcplay.com/snail/apk/snail_qc_official_0.1.40.apk';
        var id = window.location.href.split('id=')[1];
        // 有下载指定id的时候
        if (id !== undefined) {
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: "https://api.qingcigame.com/web/getdownurl?id=" + id + "",
                type: "GET",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    iosUrl = json.data.data.ios_down_url;
                    andUrl = json.data.data.android_down_url;
                    if (json.code == 200) {
                        $('.ios-btn').attr('href', iosUrl)
                        $('.and-btn').attr('href', andUrl)
                        console.log(iosUrl)
                        console.log(andUrl)
                    }

                },
                error: function() {
                    layer.msg("服务器请求失败", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
    },
    indexBind: function() {
        // 关闭下载提示
        $('.download-wrap').on('click', function() {
            $(this).fadeOut();
        });

        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qingcigame.com/snail/pay/number?id=37",
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    $('.number-data').html(json.data.number);
                    layer.close(index);
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                    layer.close(index);
                }
            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
                layer.close(index);
            }
        })
    },
    newYearTime: function() {
        var date = {
            isDuringDate: function(beginDateStr, endDateStr) {
                var curDate = new Date(),
                    beginDate = new Date(beginDateStr),
                    endDate = new Date(endDateStr);
                if (curDate >= beginDate && curDate <= endDate) {
                    $('.banner-big').addClass('new-banner-big');
                    return true;
                }
            }
        };
        date.isDuringDate('2021/02/12', '2022/02/12');
    }
}